import React from 'react';
import { observer } from 'mobx-react';
import { Input, Button } from 'antd';
import { SearchForm, AuthDiv, AuthCard  } from 'components';
import ComTable from './Table';
import store from './store';

export default observer(function () {
  return (
    <AuthCard auth="student.express.view">
      <SearchForm>
        <SearchForm.Item span={6} title="收件姓名">
          <Input allowClear onChange={e => store.f_name = e.target.value} placeholder="收件姓名"/>
        </SearchForm.Item>
        <SearchForm.Item span={6} title="收件号码">
          <Input allowClear onChange={e => store.f_mobile = e.target.value} placeholder="收件号码"/>
        </SearchForm.Item>
        <SearchForm.Item span={6} title="快递单号">
          <Input allowClear onChange={e => store.f_express_num = e.target.value} placeholder="快递单号"/>
        </SearchForm.Item>
        <SearchForm.Item span={4}>
          <Button type="primary" icon="sync" onClick={store.fetchRecords}>刷新</Button>
        </SearchForm.Item>
      </SearchForm>
      <AuthDiv auth="student.express.add" style={{ marginBottom: 16 }}>
        <Button type="primary" icon="plus" onClick={() => store.showForm()}>添加快递信息</Button>
      </AuthDiv>
      <ComTable/>
    </AuthCard>
  )
})
